import dayjs from 'dayjs';
import React from 'react';

//Estilos
import './SettingsInfo.css';

function SettingsInfo({ states, functions }) {
    const { settings } = states;

    return (
        <div className="settings_info-container">
            <h4 className="table-title">Fechas Importantes</h4>
            <label className="settings_info-label">
                <span>Cierre de Vendimia:</span>
                <p>{dayjs(settings?.cierre_vendimia).format('DD-MM-YYYY')}</p>
            </label>
            <label className="settings_info-label">
                <span>Rango para DJCP:</span>
                <p>
                    {dayjs(settings?.djcp_rango_inicio).format('DD-MM-YYYY')} al{' '}
                    {dayjs(settings?.djcp_rango_fin).format('DD-MM-YYYY')}
                </p>
            </label>
            <label className="settings_info-label">
                <span>Fecha limite para DJCE:</span>
                <p>{dayjs(settings?.djce_fecha_limite).format('DD-MM-YYYY')}</p>
            </label>
        </div>
    );
}

export default SettingsInfo;
